import { IEducationProviderAgreement } from './agreement'
import { IAmount } from './amount'
import { IApplication } from './application'
import { ICourse, ICourseWithEducationProvider } from './course'
import { IDocumentReference } from './document-reference'
import { IFinancialTerm } from './financial-term'
import { INewCheckoutPayload, IPayment } from './payment'
import { IUser } from './user'

export enum OrderPaymentTerm {
  Upfront = 'UPFRONT',
  FixPay = 'FIXPAY',
  Isa = 'ISA',
  Elsa = 'ELSA',
  Free = 'FREE',
  NoAgreement = 'NO_AGREEMENT',
}

export interface IOrder {
  _id: string
  user: IUser | string
  item: IItem
  status: OrderStatus
  totalAmount: number
  currency: string
  learningBudgetAmount?: IAmount
  // TODO: change userPaymentAmount to true when remove the deprecated code.
  userPaymentAmount?: IAmount
  payments?: IPayment[]
  paymentTerm: OrderPaymentTerm
  paymentDetails?: IDocumentReference[]
  application?: IApplication
  updatedAt: string
  createdAt: string
  checkoutPaymentOptions?: INewCheckoutPayload['paymentOptions']
  orderId?: string
}

export type IGroupedByStatusOrder = {
  status: string
  items: IOrder[]
}

export enum OrderStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}

// TODO: move agreements/financial term from item to application or order
export interface IItem {
  course: ICourse | string
  cohort: string
  agreement?: IEducationProviderAgreement | string
  financialTerm?: IFinancialTerm | string
}

export interface IOrderItemWithCourse extends Omit<IItem, 'course'> {
  course: ICourseWithEducationProvider
}

export interface IOrderWithCourseItem extends Omit<IOrder, 'item'> {
  item: IOrderItemWithCourse
}
